import { ChevronRight, SearchX } from "lucide-react";
import { Link, useRouter } from "../router/Router";
import { searchGuides, categoryById } from "../content/registry";
import { Seo } from "../components/Seo";

export function SearchPage() {
  const { search } = useRouter();
  const params = new URLSearchParams(search);
  const q = params.get("q") ?? "";
  const results = searchGuides(q);

  return (
    <div className="hc-search-page">
      <Seo title={`Search: ${q}`} noindex path="/search" />

      <nav className="hc-crumb" aria-label="Breadcrumb">
        <Link to="/">Help</Link>
        <ChevronRight size={13} aria-hidden="true" />
        <span className="hc-crumb__current">Search</span>
      </nav>

      <h1 className="hc-search-page__title">
        {results.length} result{results.length === 1 ? "" : "s"} for “{q}”
      </h1>

      {results.length === 0 ? (
        <div className="hc-empty">
          <SearchX size={28} aria-hidden="true" />
          <p>No guides matched your search. Try a different term.</p>
        </div>
      ) : (
        <div className="hc-guide-grid">
          {results.map((g) => {
            const cat = categoryById(g.category);
            return (
              <Link key={g.route} to={g.route} className="hc-guide-card">
                <span className="hc-guide-card__cat">{cat?.label}</span>
                <span className="hc-guide-card__title">{g.title}</span>
                <span className="hc-guide-card__summary">{g.summary}</span>
                <span className="hc-guide-card__more">
                  Read guide <ChevronRight size={14} aria-hidden="true" />
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
